
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buyback",
      function () {
        return require("private-next-pages/buyback/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buyback"])
      });
    }
  